/*=========================================================================================
  File Name: actions.js
  Namespace: exercises
  Description: Vuex Store - Exercise actions
==========================================================================================*/
import {
  listExercises,
  getExercise,
  createExercise,
  editExercise,
  listTests,
  createTest,
  editTest,
  deleteTest,
  listSolutions,
  createSolution,
  editSolution,
  deleteSolution,
  testSolution,
} from '@/services/exercises.service'

import {
  listFiles
} from '@/services/files.services.js'
import {
  adaptExerciseToStore
} from '@/services/adapters/exerciseAdapter.js'
import {
  shortenUUIDs
} from '@/utils/utils'

const actions = {
  async getExerciseAction({
    commit
  }, {
    exerciseId
  }) {
    const response = await getExercise({
      exerciseId
    })
    if (response) {
      commit('STORE_CURRENT_EXERCISE', response)
    }
    return response
  },
  async getAllExercises({
    commit
  }, params = {}) {
    if (params.ids && params.ids.length > 20) {
      params.ids = shortenUUIDs(params.ids)
    }
    // Not implemented
    // params.company = rootGetters['app/getSelectedCompanyName']
    const response = await listExercises(params)
    if (response) {
      commit('STORE_LIST_EXERCISES', response)
    }
    return response
  },
  async saveExerciseToApi({
    commit,
    getters
  }) {
    let response
    if (getters.getCurrentExercise.id) {
      response = await editExercise({
        ...getters.getCurrentExercise,
        files: getters.getCurrentExerciseFiles.map(f => f.id),
        exerciseId: getters.getCurrentExercise.id
      })
    } else {
      response = await createExercise({
        ...getters.getCurrentExercise,
        files: getters.getCurrentExerciseFiles.map(f => f.id),
      })
    }
    commit('STORE_CURRENT_EXERCISE', response)
    return response
  },
  saveExerciseToEdit({
    commit
  }, exercise) {
    commit('STORE_CURRENT_EXERCISE', adaptExerciseToStore({
      data: exercise
    }))
  },
  saveExerciseToEntries({
    commit
  }, exercise) {
    commit('STORE_EXERCISE_TO_LIST', {
      [exercise.id]: exercise
    })
  },
  resetCurrentExercise({
    commit
  }) {
    commit('RESET_CURRENT_EXERCISE')
  },
  async getAllExerciseFiles({
    commit
  }, files) {
    const response = await listFiles({
      ids: files
    })
    commit('STORE_CURRENT_EXERCISE_FILES', response.results)
  },

  // TESTS
  async getAllExerciseTests({
    commit
  }, params = {}) {
    const response = await listTests(params)
    if (response) {
      commit('STORE_CURRENT_EXERCISE_TESTS', response.entries)
    }
    return response
  },
  async saveTestExerciseToApi({
    commit,
    getters
  }, payload) {
    let response
    if (payload.id) {
      response = await editTest({
        exerciseId: getters.getCurrentExercise.id,
        testId: payload.id,
        ...payload
      })
    } else {
      response = await createTest({
        exerciseId: getters.getCurrentExercise.id,
        ...payload
      })
    }
    commit('STORE_CURRENT_EXERCISE_TEST', response)
    return response
  },
  async deleteATest({
    commit, getters
  }, payload = {}) {
    await deleteTest({
      exerciseId: getters.getCurrentExercise.id,
      testId: payload.testId
    })
    commit('DELETE_TEST_FROM_EXERCISE', payload)
  },

  // SOLUTIONS
  async getAllExerciseSolutions({
    commit
  }, params = {}) {
    const response = await listSolutions(params)
    if (response) {
      commit('STORE_CURRENT_EXERCISE_SOLUTIONS', response.entries)
    }
    return response
  },
  async saveSolutionExerciseToApi({
    commit,
    getters
  }, payload) {
    let response
    if (payload.id) {
      response = await editSolution({
        exerciseId: getters.getCurrentExercise.id,
        solutionId: payload.id,
        ...payload
      })
    } else {
      response = await createSolution({
        exerciseId: getters.getCurrentExercise.id,
        ...payload
      })
    }
    commit('STORE_CURRENT_EXERCISE_SOLUTION', response)
    return response
  },
  async deleteASolution({
    commit,
    getters
  }, payload = {}) {
    await deleteSolution({
      exerciseId: getters.getCurrentExercise.id,
      solutionId: payload.solutionId
    })
    commit('DELETE_SOLUTION_FROM_EXERCISE', payload)
  },

  async sendSolutionToTest({ getters }, payload) {
    const response = await testSolution({
      exerciseId: getters.getCurrentExercise.id,
      submitted_code: payload.submitted_code,
    })
    return response
  }
}

export default actions
